type ActivityListProps = {
  className?: string;
};

const ActivityList = ({ className }: ActivityListProps) => (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Group 1398">
      <path
        id="Rectangle 175"
        d="M19 4V2C19 1.44772 18.5523 1 18 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H9"
        stroke="#212121"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        id="Rectangle 179"
        x="5"
        y="5"
        width="9"
        height="2"
        rx="1"
        fill="#212121"
      />
      <rect
        id="Rectangle 181"
        x="5"
        y="9"
        width="5"
        height="2"
        rx="1"
        fill="#212121"
      />
      <path
        id="ActivityListVector"
        d="M11 16V12.925L18 6L21 9L14.075 16H11ZM12.5 14.5H13.45L16.475 11.45L16.025 10.975L15.55 10.525L12.5 13.55V14.5ZM16.025 10.975L15.55 10.525L16.475 11.45L16.025 10.975Z"
        fill="#212121"
      />
    </g>
  </svg>
);

export default ActivityList;
